module.exports = "<div class=\"containers-wrapper\">\n  <yi-main></yi-main>\n  <yi-side></yi-side>\n</div>\n    ​\n"